












import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin, isMobile } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = 'ZGZJ1114';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};
  beforeRouteEnter(to: any, from: any, next: any) {
    if (!isMobile()) {
      // 跳转到pc
      window.location.href =
        process.env.VUE_APP_ENV_NAME === 'production'
          ? 'https://activity.cqcb.com/shangyou_activity/ZGZJ1114/'
          : 'https://testdev.cqcb.com/ZGZJ1114/';
    } else {
      next();
    }
    next();
  }
  beforeCreate() {
    if (!isMobile()) {
      // 跳转到pc
      window.location.href =
        process.env.VUE_APP_ENV_NAME === 'production'
          ? 'https://activity.cqcb.com/shangyou_activity/ZGZJ1114/'
          : 'https://testdev.cqcb.com/ZGZJ1114/';
    }
  }
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '职工之家成果展示',
      url: location.href,
      subtitle: `职工之家成果展示`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '职工之家成果展示',
        subtitle: `职工之家成果展示`,
        image: cover,
      });
    }
  }
  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    console.log('baseinfo:', ret.data);
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
